import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Swal from 'sweetalert2';
import { LoginUser, LoginWithGoogle } from '../../api/user.api';
import { jwtDecode } from "jwt-decode";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { setCurrentUser } from '../../Redux/User/userAction';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';

interface GoogleCredentials {
  email: string;
}
const Login = () => {
  const [UserEmail, setUserEmail] = useState('');
  const [UserPassword, setUserPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const handleLogin = async () => {
    if (UserEmail && UserPassword) {
      // שמירת המייל ב־sessionStorage גם אם ההתחברות תיכשל
      sessionStorage.setItem("email", UserEmail);
      console.log('Logging in with', { UserEmail, UserPassword });
      try {
        const response = await LoginUser(UserEmail, UserPassword);
        if (response.status === 200) {
          const x = response;
          console.log(x);
          console.log("success login");
          // alert("good login")
          
          console.log(x.data);
          MySwal.fire({
            title: 'success',
            text: 'התחברת בהצלחה',
            icon: 'success',
             showConfirmButton: false, // הסתרת כפתור האישור
                                 timer: 3000, // סגירה אוטומטית אחרי 3 שניות
          });
          dispatch(setCurrentUser(x.data));
          sessionStorage.setItem("userId", x.data.id);
          sessionStorage.setItem("userType", x.data.userType.description);
          sessionStorage.setItem("firstName", x.data.firstName);
          sessionStorage.setItem("lastName", x.data.lastName);
          sessionStorage.setItem("email", x.data.email);
          if (x.data.userType.description === "לקוח")
            navigate("/quickActions");
          else if (x.data.userType.description === "מנהל")
            navigate("/allDeshbord");
          else
            navigate("/allDeshbord");
        }
      } catch (error: any) {
        console.log("Response Error:", error.response);
        let errorMessage = 'שגיאה כללית';
        console.log(error.response);
        if (error.response) {
          if (error.response.status === 401) {
            errorMessage = 'סיסמה שגויה';
          } else if (error.response.status === 404) {
            errorMessage = 'משתמש לא קיים';
          }
        } else {
          errorMessage = 'בעיה בחיבור לשרת';
        }
        MySwal.fire({
          title: 'error',
          text: errorMessage,
          icon: 'error',
         showConfirmButton: false, // הסתרת כפתור האישור
                                 timer: 3000, // סגירה אוטומטית אחרי 3 שניות
        });
      }
    } else {
      alert('נא להכניס מייל וסיסמא');
    }
  };
  const clientId = '712110921118-7lmsam5ji19333th54fv96cf4k54fk1q.apps.googleusercontent.com';
  const onSuccess = (googleUser: any) => {
    console.log('Login Success:', googleUser);
    const credentials = jwtDecode<GoogleCredentials>(googleUser.credential);
    console.log(credentials);
    LoginWithGoogle(credentials.email).then((response) => {
      if (response.status === 200) {
        const x = response;
        console.log(x);
        console.log(x.data);
        MySwal.fire({
          title: 'success',
          text: 'התחברת בהצלחה',
          icon: 'success',
              showConfirmButton: false, // הסתרת כפתור האישור
                                 timer: 3000, // סגירה אוטומטית אחרי 3 שניות
        });
        sessionStorage.setItem("userId", x.data.id);
        sessionStorage.setItem("userType", x.data.userType.description);
        sessionStorage.setItem("firstName", x.data.firstName);
        sessionStorage.setItem("lastName", x.data.lastName);
        sessionStorage.setItem("email", x.data.email);
        if (x.data.userType.description === "לקוח")
          navigate("/quickActions");
        else if (x.data.userType.description === "מנהל") {
          navigate("/allDeshbord");
        }
        else
          navigate("/allDeshbord");
      } else {
        let errorMessage = 'סיסמה שגויה';
        if (response.status === 404) {
          errorMessage = 'משתמש לא קיים';
        }
        MySwal.fire({
          title: 'error',
          text: errorMessage,
          icon: 'error',
                     showConfirmButton: false, // הסתרת כפתור האישור
                                 timer: 3000, // סגירה אוטומטית אחרי 3 שניות
        });
      }
    })
      .catch((error) => {
        console.log(error);
        MySwal.fire({
          title: 'error',
          text: 'שגיאה בהתחברות ',
          icon: 'error',
           showConfirmButton: false, // הסתרת כפתור האישור
                                 timer: 3000, // סגירה אוטומטית אחרי 3 שניות
        });
      });
  };
  const onFailure = () => {
    console.log('Login Failed');
  };
  const Login = () => {
    const navigate = useNavigate();
  };
  return (
    <div className='login'>
      <p id='p' style={{ marginTop: '110px' }}>התחברות למערכת</p>
      <div className='conectGoogle'>
        <button type="button" className='linkq'>
          <GoogleOAuthProvider clientId={clientId}>
            <div className="custom-google-login-button">
              <GoogleLogin
                onSuccess={onSuccess}
                onError={onFailure}
              />
            </div>
          </GoogleOAuthProvider>
        </button>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
        <div id='allin'>
          <input
            id="username"
            placeholder=":הכנס אימייל"
            className='textBox'
            value={UserEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
          />
          <div>
            <input
              type={!showPassword ? 'password' : ''}
              id="password"
              placeholder=':סיסמא'
              className='textBox'
              value={UserPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              required
            />
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </span>
          </div>
          {UserEmail ? (
       <Link
          to="/reset-password"
           className="forgot-password-link"
           onClick={() => sessionStorage.setItem('email', UserEmail)}
          >
           שכחת סיסמה?
         </Link>
      ) : (
      <span
       className="forgot-password-link"
       onClick={() => alert('אנא הזן מייל לפני שחזור סיסמה')}
       style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
      >
        שכחת סיסמה?
      </span>
    )}


          <div id='btn'>
            <button type="submit" className='textBox' id="submit">
              <div id='en'>
                <span className='enter'>
                  <svg width="20" height="20" fontSize={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='ok'>
                    <path d="M0.00598005 4.00597L1.90735e-06 20L16 19.998L16.002 18L3.41396 18L20 1.414L18.586 -1.78373e-06L1.99997 16.586L1.99996 3.99999L0.00598005 4.00597Z" fill="#002046" />
                  </svg> כניסה
                </span>
              </div>
            </button>
          </div>
        </div>
      </form>
    </div>

  );
}
export default Login;









